// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fbe28fab","453":"a0ffd968","644":"f0cbc055","745":"fb1fffa6"}[chunkId] + ".chunk.js";
};